import React from "react";
import {isRSAA, RSAA} from "redux-api-middleware";
import {setNotification} from "../actions/notifications-actions";
import ReactOnRails from 'react-on-rails';
import {authInit as authInitAction, expired} from "../actions/auth-actions";
import Cookies from "universal-cookie";
import {push} from 'react-router-redux';

const cookies = new Cookies();

export const authInit = (store) => {
    store.dispatch(authInitAction());
};

export const authApiWrapper = (store) => (next) => (action) => {
    if(!isRSAA(action)) {
        return next(action);
    }

    const {auth, ...rsaaAction} = action;
    if (!auth) {
        return next(rsaaAction);
    }

    let token = cookies.get('_yourchance_competition_session_ctt') || ReactOnRails.authenticityToken();
    let modifiedHeaders = { ...rsaaAction[RSAA].headers, 'X-CSRF-Token': token };

    return (async() => {
        const response = await next({ [RSAA]: { ...rsaaAction[RSAA], headers: modifiedHeaders }});
        return response;
    })();
};

export const apiUnauthorizedWrapper = (store) => next => (action) => {
    if(!isRSAA(action)) {
        return next(action);
    }

    const {onFailure, ...rsaaAction} = action;
    if(!onFailure) {
        return (async() => {
            const response = await next(rsaaAction);
            if(response.error) {
                const state = store.getState();
                if (response.payload.status === 401 && state.auth.isAuthenticated) {
                    store.dispatch(expired());
                    store.dispatch(push('/'));
                    store.dispatch(setNotification('warning', 'You are no longer being signed in.'));
                }
            }
            return response;
        })();
    }

    return (async() => {
        const response = await next(rsaaAction);
        if(response.error && onFailure) {
            store.dispatch(onFailure);
        } else if(onSuccess) {
            store.dispatch(onSuccess);
        }
        return response;
    })();
};
